/* 用户身份选择埋点
* profile: {
*   $预置属性
*   所在页面  page_title
* }
* */
function customRegisterButtonClick(profile = {}) {
  sensors.track('RegisterButtonClick', profile);
}

/* 用户身份选择埋点
* profile: {
*   $预置属性
*   用户身份  userType
* }
* */
function customUserIdentitySelect(profile = {}) {
  sensors.track('userIdentitySelect', profile);
}

/* 填写企业信息
* profile: {
*   $预置属性
*   org_id	企业编号	字符串
*   org_name	企业名称	字符串
*   is_first_time	是否首次	BOOL
* }
*/
function customCompanyInformation(profile = {}) {
  sensors.track('companyInformation', profile);
}

/* 完善个人信息
* profile: {
*   $预置属性
*   org_id	企业编号	字符串
*   org_name	企业名称	字符串
*   user_name	用户名	字符串
*   mobile	手机	字符串
* }
*/
function customPersonalInformation(profile = {}) {
  sensors.track('personalInformation', profile);
}

/* 提交审核
* profile: {
*   $预置属性
*   org_id	企业编号	字符串
*   org_id	企业编号	字符串
* }
*/
function customSubmitAudit(profile = {}) {
  sensors.track('submitAudit', profile);
}

/* 点击登录按钮
* profile: {
*   $预置属性
* }
*/
function customLoginButtonClick(profile = {}) {
  sensors.track('loginButtonClick', profile);
}

/* 点击搜索按钮
* profile: {
*   $预置属性
*   position	所在位置	字符串 招标公告下商机搜索，资源大厅
* }
*/
function customSearchButtonClick(profile = {}) {
  sensors.track('searchButtonClick', profile);
}

/* 点击搜索结果
* profile: {
*   $预置属性
*  position	所在位置	字符串 招标公告下商机搜索，资源大厅
*  new_keyword	关键词
*  keyword_type	关键词类型	搜索栏下面的推荐分类、输入搜索
*  position_number	位置序号
*  project_name	项目名称
*  supplier	供应商名称
* }
*/
function customSearchResultClick(profile = {}) {
  sensors.track('searchResultClick', profile);
}

/* tab点击
* profile: {
*   $预置属性
*   position	所在位置	字符串	供应商，采购商，首页顶部
*   tab_name	tab名称	字符串	招标公告，询报价，中标公示
* }
*/
function customTabClick(profile = {}) {
  sensors.track('tabClick', profile);
}

/* 运营位点击
* profile: {
*   $预置属性
*   page_title	所在页面	字符串	门户首页，招标公告，资源大厅，招标公告
*   operation_type	运营位类型	字符串	轮播图，除了banner以后可能会有其他形式（门户轮播1，门户轮播2，门户轮播3，门户轮播4，门户轮播5，门户轮播5，以此类推资源大厅1-6，招标公告1-6）
*   operation_content	运营位内容	字符串	广告图片，招标公告，供应商logo，采购商logo
*   operation_name	运营位名称	字符串	用于区别每一个运营位
*   operation_id	运营位id	字符串	技术同事确认是否有这个属性
* }
*/
function customOperationClick(profile = {}) {
  sensors.track('operationClick', profile);
}

/* 活动页浏览
* profile: {
*   $预置属性
*   page_title	所在页面	字符串	安心采，诚意供
* }
*/
function customActivityDetail(profile = {}) {
  sensors.track('activityDetail', profile);
}

/* 活动页立即购买
* profile: {
*   $预置属性
*   page_title	所在页面	字符串	安心采，诚意供
*   button_position	按钮位置	字符串	活动页下面两个立即购买按钮，分析哪一个点击率高
* }
*/
function customActivityDetailBuyNow(profile = {}) {
  sensors.track('activityDetailBuyNow', profile);
}

/* 添加入库
* profile: {
*   $预置属性
*   position	所在位置	字符串	门户，资源大厅
*   org_id	企业编号	字符串
*   org_name	企业名称	字符串
*   org_credit	企业征信	字符串
* }
*/
function customAddInStorag(profile = {}) {
  sensors.track('addInStorag', profile);
}

/* 添加关注
* profile: {
*   $预置属性
*   position	所在位置	字符串	门户，资源大厅
*   org_id	企业编号	字符串
*   company	企业名称	字符串
*   org_credit	企业征信	字符串
* }
*/
function customAddConcern(profile = {}) {
  sensors.track('addConcern', profile);
}


/* 首页浏览
* profile: {
*   $预置属性
*   user_name	钉钉用户姓名
*   user_email 钉钉用户邮箱
* }
*/
function customHomePageView(profile = {}) {
  sensors.track('homePageView', profile);
}

/* 模块点击
* profile: {
*   $预置属性
*   module_type	模块类型
*   module_name 模块名称
* }
*/
function customModuleClick(profile = {}) {
  sensors.track('moduleClick', profile);
}

/* BI看板列表点击
* profile: {
*   $预置属性
*   bulletin_board_type 看板类型
*   bulletin_board_name 看板名称
* }
*/
function customBulletinBoardClick(profile = {}) {
  sensors.track('bulletinBoardClick', profile);
}

/* 弹窗点击
* profile: {
*   $预置属性
*   popup_name 弹窗名称
*   button_name 按钮名称
* }
*/
function customPopupClick(profile = {}) {
  sensors.track('popupClick', profile);
}

/* 规章制度
* profile: {
*   $预置属性
*   document_type 文档类型 规章制度、学习资料
*   document_name 文件名称
* }
*/
function customDocumentlistclick(profile = {}) {
  sensors.track('documentlistclick', profile);
}

/* BI看板页浏览*/
function customBulletinBoardPageView() {
  sensors.track('bulletinBoardPageView');
}

export {
  customRegisterButtonClick,
  customUserIdentitySelect,
  customCompanyInformation,
  customPersonalInformation,
  customSubmitAudit,
  customLoginButtonClick,
  customSearchButtonClick,
  customSearchResultClick,
  customTabClick,
  customOperationClick,
  customActivityDetail,
  customActivityDetailBuyNow,
  customAddInStorag,
  customAddConcern,

  customHomePageView,
  customModuleClick,
  customBulletinBoardClick,
  customPopupClick,
  customDocumentlistclick,
  customBulletinBoardPageView

}


// WEBPACK FOOTER //
// ./src/assets/js/sensors.js